<ul class="timeline" *ngIf="versionHistoryItem">
  <li class="timeline__item" *ngFor="let item of versionHistoryItem.fullHistory">
    <ng-container *ngIf="!item.isAuthHistory; else auth">
      <div class="date-container">
        <span class="date-container__date">
          {{ item.updatedAt | date: 'MMMM d, yyyy hh:mm a [UTC]' : ' +0000' }}
        </span>
      </div>
      <div class="state-n-user-info">
        <q9-user-info
          [user]="item.who"
          [matTooltip]="item?.who?.email"
          [matTooltipDisabled]="!item?.who?.email"
          matTooltipPosition="below"></q9-user-info>
        <div class="state-n-user-info__state">New state: {{ item.what | versionState }}</div>
        <div class="state-n-user-info__comment">
          {{ item.comment | htmlEncoder: true }}
        </div>
      </div>
    </ng-container>
    <ng-template #auth>
      <div class="date-container">
        <span class="date-container__date">
          {{ item.when | date: 'MMMM d, yyyy hh:mm a [UTC]' : ' +0000' }}
        </span>
      </div>
      <div class="state-n-user-info">
        <q9-user-info
          [user]="item.who"
          [matTooltip]="item?.who?.email"
          [matTooltipDisabled]="!item?.who?.email"
          matTooltipPosition="below"></q9-user-info>
        <div class="record">
          <span *ngIf="!item?.config?.needTransition; else transition" class="count-label">
            <q9-tag [color]="item.config.color">{{ item.config.label | translate }}</q9-tag>
          </span>
        </div>

        <ng-template #transition>
          <span class="record__transition">
            <span class="count-label">
              <q9-tag [color]="item?.config?.transitionConfig?.fromColor">
                {{ item?.config?.transitionConfig?.from | translate }}
              </q9-tag>
            </span>
            <mat-icon svgIcon="arrow_right-icon"></mat-icon>
            <span class="count-label">
              <q9-tag [color]="item?.config?.transitionConfig?.toColor">
                {{ item?.config?.transitionConfig?.to | translate }}
              </q9-tag>
            </span>
          </span>
        </ng-template>

        <div class="record__target" *ngIf="item?.config?.targetLabel">
          <span class="record__target--label">
            {{ item?.config?.targetLabel | translate }}:&nbsp;
          </span>
          <div
            class="record__target--user"
            [matTooltip]="item?.targetUser?.email"
            [matTooltipDisabled]="!item?.targetUser?.email"
            matTooltipPosition="below">
            {{ item?.targetUser?.email }}
          </div>
        </div>

        <div class="state-n-user-info__comment">
          {{ item.reason | htmlEncoder: true }}
        </div>
      </div>
    </ng-template>
  </li>
</ul>
